/* eslint-disable no-param-reassign */
export const validaUpload = ({ e, setModalIsOpen, form, anexo }) => {
  const convertFileListIntoArray = [...e.currentTarget.files];
  const filteredFilesByType = convertFileListIntoArray.filter(
    (file) => file.type.includes('image/') || file.type.includes('pdf')
  );

  const dataTransfer = new DataTransfer();

  filteredFilesByType.forEach((file) => dataTransfer.items.add(file));

  if (e && e.currentTarget && e.currentTarget.files) {
    e.currentTarget.files = dataTransfer.files;
    e.target.files = dataTransfer.files;
  }

  if (convertFileListIntoArray.length !== filteredFilesByType.length) {
    setModalIsOpen(true);
  }

  return form.setFieldValue(
    anexo.name,
    filteredFilesByType.length ? dataTransfer.files : null
  );
};
